export const TOGGLE_TIKTOK_CHANNEL_REQUEST = 'TOGGLE_TIKTOK_CHANNEL_REQUEST'
export const TOGGLE_TIKTOK_CHANNEL_RESPONSE = 'TOGGLE_TIKTOK_CHANNEL_RESPONSE'
export const TOGGLE_TIKTOK_CHANNEL_ERROR = 'TOGGLE_TIKTOK_CHANNEL_ERROR'
